import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const client = axios.create({ baseURL: API });

export const getPrograms = () => client.get("/programs").then((r) => r.data);
export const getProgram = (slug) => client.get(`/programs/${slug}`).then((r) => r.data);
export const getVideos = (programId) =>
  client.get("/videos", { params: programId ? { programId } : {} }).then((r) => r.data);
export const getVideo = (id) => client.get(`/videos/${id}`).then((r) => r.data);
export const getLiveStreams = () => client.get("/live-streams").then((r) => r.data);
export const getMainLive = () => client.get("/live-streams/main").then((r) => r.data);

export const pingLivePresence = (streamId, sessionId) =>
  client.post(`/live-streams/${streamId}/presence`, { sessionId }).then((r) => r.data);

export const leaveLivePresence = (streamId, sessionId) =>
  client.post(`/live-streams/${streamId}/leave`, { sessionId }).then((r) => r.data);
export const getHeroSlides = () => client.get("/hero-slides").then((r) => r.data);
export const sendContact = (payload) => client.post("/contact", payload).then((r) => r.data);

// Extract a YouTube video id from various URL formats
export const getYoutubeId = (url) => {
  if (!url) return null;
  const patterns = [
    /(?:youtube\.com\/watch\?v=)([\w-]{11})/,
    /(?:youtu\.be\/)([\w-]{11})/,
    /(?:youtube\.com\/embed\/)([\w-]{11})/,
    /(?:youtube\.com\/live\/)([\w-]{11})/,
    /(?:youtube\.com\/shorts\/)([\w-]{11})/,
  ];
  for (const p of patterns) {
    const m = url.match(p);
    if (m) return m[1];
  }
  return null;
};

export const getYoutubeEmbed = (url, autoplay = true) => {
  const id = getYoutubeId(url);
  if (!id) return null;
  return `https://www.youtube.com/embed/${id}?autoplay=${autoplay ? 1 : 0}&rel=0&modestbranding=1`;
};
